<template>
  <div class="pt-5">
    <v-row v-if="filtersReady">
      <component
        v-for="(item, index) in selectedProxyPackageFilters"
        :key="index"
        :is="item"
        :label="availableProxyPackageFilters[item]"
        v-model="filters[item]"
        @remove="removeFilter(item)"
      ></component>
      <v-col
        :sm="isEmpty(availableFilters) ? 6 : 12"
        :md="isEmpty(availableFilters) ? 4 : 8"
        :lg="isEmpty(availableFilters) ? 2 : 4"
        class="align-self-center"
      >
        <v-menu
          v-if="!isEmpty(availableFilters)"
          top
          :close-on-content-click="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              outlined
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              class="mr-2"
            >
              <v-icon x-small>mdi-plus</v-icon>
              Add filter
            </v-btn>
          </template>

          <v-list width="250px">
            <v-list-item-group>
              <v-virtual-scroll
                :height="availableFilters.length * 40"
                :itemHeight="40"
                :items="availableFilters"
              >
                <template v-slot:default="{ item }">
                  <v-list-item>
                    <v-list-item-title @click="addFilter(item.key)">{{
                      item.label
                    }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-btn
          x-small
          outlined
          color="grey darken-1"
          dark
          @click="resetFilters"
        >
          reset Filters
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { emptyFilters } from "@/store/modules/proxyPackage/state";
import {
  ADD_PROXY_PACKAGE_FILTER,
  REMOVE_PROXY_PACKAGE_FILTER,
  SET_DEFAULT_PROXY_PACKAGE_FILTERS,
  SET_PROXY_PACKAGE_FILTERS,
} from "@/store/modules/persistentStorage/actions";
import { SET_EMPTY_FILTERS } from "@/store/modules/proxyPackage/actions";
import TextFilter from "@/views/components/searchParts/TextFilter";

export default {
  name: "ProxyPackageSearch",
  components: {
    name: TextFilter,
  },
  data: function () {
    return {
      filtersReady: false,
    };
  },
  computed: {
    ...mapGetters("proxyPackage", ["filters"]),
    ...mapGetters("persistentStorage", [
      "selectedProxyPackageFilters",
      "availableProxyPackageFilters",
    ]),
    availableFilters: function () {
      let vm = this;
      let result = [];

      const filtersToSelect = _.difference(
        _.keys(emptyFilters),
        this.selectedProxyPackageFilters
      );

      filtersToSelect.forEach(function (filter) {
        result.push({
          key: filter,
          label: _.get(vm.availableProxyPackageFilters, filter),
        });
      });
      return result;
    },
  },
  watch: {
    selectedProxyPackageFilters: {
      handler: function () {
        let query = _.merge({}, this.$route.query);
        query["selectedFilters"] = _.merge(
          [],
          this.selectedProxyPackageFilters
        );
        query["page"] = this.$route.query.page;
        this.$router.push({ name: this.$route.name, query: {} }).catch((e) => {
          console.log(e);
        });
        this.$router
          .push({ name: this.$route.name, query: query })
          .catch(() => {});
      },
      deep: true,
    },
  },
  methods: {
    addFilter: function (filter) {
      this.$store.dispatch(
        `persistentStorage/${ADD_PROXY_PACKAGE_FILTER}`,
        filter
      );
    },
    removeFilter: function (filter) {
      this.$store.dispatch(
        `persistentStorage/${REMOVE_PROXY_PACKAGE_FILTER}`,
        filter
      );
      this.filters[filter] = null;
    },
    resetFilters: function () {
      this.$store.dispatch(`proxyPackage/${SET_EMPTY_FILTERS}`);
      this.$store.dispatch(
        `persistentStorage/${SET_DEFAULT_PROXY_PACKAGE_FILTERS}`
      );
    },
    isEmpty: function (value) {
      return _.isEmpty(value);
    },
  },
  mounted() {
    const vm = this;
    if (!_.isEmpty(vm.$route.query) && vm.$route.query["selectedFilters"]) {
      let selectedFilters = vm.$route.query["selectedFilters"];
      if (!(selectedFilters instanceof Array)) {
        selectedFilters = [selectedFilters];
      }
      this.$store.dispatch(
        `persistentStorage/${SET_PROXY_PACKAGE_FILTERS}`,
        selectedFilters
      );
    }
    if (!_.isEmpty(vm.$route.query)) {
      _.forIn(vm.$route.query, function (value, filter) {
        if (_.find(vm.availableFilters, ["key", filter])) {
          vm.addFilter(filter);
        }
      });
    }
    vm.filtersReady = true;
  },
};
</script>
